import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { FileText } from 'lucide-react';

export function ScoreChangeReasons({ reasons = [] }) {
  return (
    <Card className="bg-card border-border/80" data-testid="score-change-reasons-card">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <FileText className="w-4 h-4 text-[hsl(264,92%,70%)]" />
          <CardTitle className="text-base font-semibold">Why Did My Score Change</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-muted-foreground mb-4">
          Based on recent account signals, your enforcement risk score changed over the last week due to:
        </p>
        <div className="space-y-3">
          {reasons.map((r, i) => (
            <div key={i} className="flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <span className="w-2.5 h-2.5 rounded-sm bg-[hsl(264,92%,70%)] flex-shrink-0" />
                <span className="text-sm">{r.reason}</span>
              </div>
              <span className={cn('text-sm font-semibold tabular-nums ml-3',
                r.delta < 0 ? 'text-[hsl(0,84%,60%)]' : 'text-[hsl(142,72%,45%)]'
              )}>
                {r.delta > 0 ? '+' : ''}{r.delta}
              </span>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-4">Higher scores indicate increased risk</p>
        <Link to="/signals" className="text-xs text-[hsl(188,100%,55%)] hover:underline mt-1 inline-block">
          View Details
        </Link>
      </CardContent>
    </Card>
  );
}
